import { WebhooksApiClient } from '@fourthwall/services/dist/WebhooksApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useTestWebhookConfigurationMutation = createMutationHook(
  WebhooksApiClient.testWebhookConfiguration,
  {
    mutationKey: ['testWebhookConfiguration'],
  },
)
